import { STALE_TIME } from "#app/http/ReactQueryProvider";
import { fetchQuoteRequestTransport } from "#modules/quoteRequests/infra/fetchQuoteRequestTransport.api";
import { queryKeys } from "#shared/queryKeys/queryKeys";

export const quoteRequestTransportQuery = (id: string | undefined) => ({
  queryKey: queryKeys.quoteRequests.transport(id),
  queryFn: () => fetchQuoteRequestTransport(id!),
  staleTime: STALE_TIME,
  enabled: !!id,
});
